import { render, staticRenderFns } from "./admin_component.vue?vue&type=template&id=f37af79c&scoped=true&"
import script from "./admin_component.vue?vue&type=script&lang=js&"
export * from "./admin_component.vue?vue&type=script&lang=js&"
import style0 from "./admin_component.vue?vue&type=style&index=0&id=f37af79c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37af79c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f37af79c')) {
      api.createRecord('f37af79c', component.options)
    } else {
      api.reload('f37af79c', component.options)
    }
    module.hot.accept("./admin_component.vue?vue&type=template&id=f37af79c&scoped=true&", function () {
      api.rerender('f37af79c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/administration/admin_component.vue"
export default component.exports